import store from "@/store";

let utils = {
    
};

export default utils;